import React from "react";
import { Breadcrumb } from "react-bootstrap";
import DashBoardLayerOne from "../../../components/DashBoardLayerOne";
import { useAppServices } from "../../../hook/services";
import { useEffect } from "react";

const Dashboard = () => {
  const AppService = useAppServices();

  const getData = async () => {
    const { response } = await AppService.agency.get();
  };
  useEffect(() => {
    // Open the submenu that contains the active route
    getData();
  }, []);
  return (
    <>
      <Breadcrumb title="AI" />

      {/* DashBoardLayerOne */}
      <DashBoardLayerOne />
    </>
  );
};

export default Dashboard;
